<template>
  <DetailsAsideLayout
    data-test-id="UserDetailsWrap__detailsAsideLayout"
  >
    <template v-slot:detailsContent>
      <UserResources
        v-if="isItemBeingUpdated"
        data-test-id="UserDetailsWrap__UserResources"
        @changeTab="navigateToAsideTab"
      />
      <ScheduledEvents
        v-if="isItemBeingUpdated"
        data-test-id="UserDetailsWrap__ScheduledEvents"
      />
      <MainUserDetailsForm
        data-test-id="UserDetailsWrap__MainUserDetailsForm"
        :handleValueChange="handleValueChange"
        :parentType="parentType"
      />
      <UserSecurityForm
        data-test-id="UserDetailsWrap__UserSecurityForm"
        :handleValueChange="handleValueChange"
        :parentType="parentType"
      />
      <EmploymentInformation
        data-test-id="UserDetailsWrap__EmploymentInformation"
        :handleValueChange="handleValueChange"
        :parentType="parentType"
      />
      <PersonalEmployeeInformation
        data-test-id="UserDetailsWrap__PersonalEmployeeInformation"
        :handleValueChange="handleValueChange"
        :parentType="parentType"
      />
      <CustomAttributes
        data-test-id="UserDetailsWrap__CustomAttributes"
        :parentType="parentType"
      />
      <PublicKeys
        v-if="isItemBeingUpdated"
        data-test-id="UserDetailsWrap__PublicKeys"
        :parentType="parentType"
      />
    </template>
  </DetailsAsideLayout>
</template>

<script>
import AsidePanelChildComponentMethodsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentMethodsMixin';
import AsidePanelChildComponentPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentPropsMixin';
import CustomAttributes from 'client/systemusers/UserDetails/CustomAttributes.vue';
import DetailsAsideLayout from 'client/components/AsidePanel/Details/DetailsAsideLayout.vue';
import EmploymentInformation from 'client/systemusers/UserDetails/EmploymentInformation.vue';
import MainUserDetailsForm from 'client/systemusers/UserDetails/MainUserDetailsForm.vue';
import PersonalEmployeeInformation from 'client/systemusers/UserDetails/PersonalEmployeeInformation.vue';
import PublicKeys from 'client/systemusers/UserDetails/PublicKeys.vue';
import ScheduledEvents from 'client/systemusers/UserDetails/ScheduledEvents/ScheduledEvents.vue';
import UserResources from 'client/systemusers/UserDetails/UserResources/UserResources.vue';
import UserSecurityForm from 'client/systemusers/UserDetails/UserSecurityForm.vue';

export default {
  name: 'UserDetailsWrap',

  components: {
    CustomAttributes,
    DetailsAsideLayout,
    EmploymentInformation,
    MainUserDetailsForm,
    PersonalEmployeeInformation,
    PublicKeys,
    ScheduledEvents,
    UserResources,
    UserSecurityForm,
  },

  inject: ['$validator'],

  mixins: [
    AsidePanelChildComponentMethodsMixin,
    AsidePanelChildComponentPropsMixin,
  ],

  props: {
    navigateToAsideTab: {
      type: Function,
      default: () => {},
    },
  },

  beforeCreate() {
    this.$options.methods.asidePanelChildComponentHandleBeforeCreate(this.$options);
  },

  methods: {
    handleValueChange(value, key) {
      this.setItemField({ key, value });
    },
  },
};
</script>
